import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (
      response?.status === 401 &&
      config &&
      !config.__retried &&
      !config.url.includes("/auth/login") &&
      !config.url.includes("/auth/me") &&
      !config.url.includes("/auth/refresh")
    ) {
      config.__retried = true;
      try {
        await api.post("/auth/refresh");
        return api(config);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err, fallback = "Une erreur est survenue") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
